import React, { useState, useEffect, useContext } from "react";
import Form from "react-bootstrap/Form";
import BannerSection from "../inc/BannerSection";
import Banner from "../images/banner.jpg";
import Button from "react-bootstrap/Button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SuccessIcon from "../images/success.svg";
import Modal from "react-bootstrap/Modal";
import Image from "react-bootstrap/Image";
import { AuthContext } from "../../utility/services/AuthContext";
import { toast } from "react-toastify";
import Functions from "../../utility/services/Functions";
import ApiService from "../../utility/services/ApiService";
import Loader from "../common/Loader";
import { loadStripe } from "@stripe/stripe-js";
import ReactLoader from "react-js-loader";
import { trackScreenView, trackButtonClick, trackEvent, getUserTrackingParams } from "../../utility/services/analyticsService";
import {
  useStripe,
  useElements,
  Elements,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";

const env_config = process.env;
const isProduction = env_config.REACT_APP_PRODUCTION_MODE == "true";
const STRIPE_PUBLIC_KEY = isProduction
  ? env_config.REACT_APP_STRIPE_PUBLIC_KEY_LIVE
  : env_config.REACT_APP_STRIPE_PUBLIC_KEY_TEST;
const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

const EnterPaymentDetails = () => {
  // LOGICAL VARIABLES
  const errorStyle = {
    position: "relative",
    top: -30,
    left: -8,
  };

  const location = useLocation();
  const navigate = useNavigate();
  const { therapistDetails, priceData, date, time } = location.state;

  const [submit, setSubmit] = useState(false);
  const [showCardFields, setShowCardFields] = useState(false);
  const [initial_loading, setInitialLoading] = useState(false);
  const [validationsRes, setValidationsRes] = useState({});
  const [couponList, setCouponList] = useState([]);
  const [coupon, setCoupon] = useState({});
  const isCouponApplied = Object.keys(coupon).length > 0;

  const calculated_price = (() => {
    let Price = Number(priceData.price);
    if (isCouponApplied) {
      if (coupon.discount_type == "amount") {
        if (coupon.discount_value > Price) {
          Price = 0;
        } else {
          Price = Number(Price) - Number(coupon.discount_value);
        }
      } else {
        const percentage =
          (Number(Price) * Number(coupon.discount_value)) / 100;
        Price = Number(Price) - percentage;
      }
    }
    return Price.toFixed(2);
  })();

  const calculated_discount = (() => {
    let Price = Number(priceData.price);
    let discount = Number(coupon.discount_value);
    if (isCouponApplied) {
      if (coupon.discount_type == "amount") {
        if (coupon.discount_value > Price) {
          discount = Price;
        }
      } else {
        discount = (Number(Price) * Number(coupon.discount_value)) / 100;
      }
    }
    return discount.toFixed(2);
  })();

  const { setLoading, user } = useContext(AuthContext);
  const {
    consoleService,
    formet_date,
    formet_time,
    capitalizeFirstLetter,
    getCardBrandIconPath,
    simpleArrayString,
  } = Functions();
  const {
    create_card,
    add_booking,
    get_card_list,
    set_default_card,
    get_coupons_list,
  } = ApiService();

  // DATA VARIABLES

  const [cardList, setCardList] = useState([]);

  const [modalShow, setModalShow] = React.useState(false);
  const [couponModal, setCouponModal] = React.useState(false);

  const handleCouponModal = () => {
    setCouponModal(!couponModal);
  };

  // USE EFFECTS

  useEffect(() => {
    trackScreenView("checkout_screen", {
      screen_name: "Payment Details",
      ...getUserTrackingParams(user),
      therapist_name: therapistDetails?.name,
      session_type: `${priceData?.time_in_min}min`,
      value: priceData?.price,
      currency: "USD",
    });
    getCardListFun();
  }, []);

  // FUNCTIONS

  const getCardListFun = async () => {
    setLoading(true);
    try {
      const res = await get_card_list();

      if (res.status === 1) {
        setCardList([...res.data]);
        await getCouponListFun();

        res.data.length < 1
          ? setShowCardFields(true)
          : setShowCardFields(false);
        setTimeout(() => {
          setInitialLoading(true);
          setLoading(false);
        }, 3000);
      } else {
        setLoading(false);
        toast(res.message, {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in getCardDetailsFun function = ", err);
    }
  };

  // GET COUPON LIST

  const getCouponListFun = async () => {
    try {
      const res = await get_coupons_list();
      if (res.status === 1) {
        setCouponList([...res.data]);
        return;
      } else {
        consoleService("Error in getCardDetailsFun function = ", res.message);
      }
    } catch (err) {
      consoleService("Error in getCardDetailsFun function = ", err);
    }
  };

  const proceedfun = async () => {
    const paymentTrackParams = {
      ...getUserTrackingParams(user),
      therapist_name: therapistDetails?.name,
      session_type: `${priceData?.time_in_min}min`,
      value: calculated_price,
      currency: "USD",
    };
    trackButtonClick("pay_now_cta", { button_name: `Pay $${calculated_price}`, screen_name: "Payment Details", payment_method: "existing_card", ...paymentTrackParams });
    setLoading(true);
    try {
      if (!(cardList.length > 0)) return;
      const find_payment_method = cardList.find((item) => item.default);
      const data = {
        therapist_id: therapistDetails._id,
        pricing_id: priceData.id,
        slot_minutes: priceData.time_in_min,
        price: priceData.price,
        coupon_id: isCouponApplied ? coupon._id : "",
        date,
        time,
        payment_method: find_payment_method.id,
      };
      trackEvent("start_booking_req", { event_type: "event", screen_name: "Payment Details", payment_method: "existing_card", ...paymentTrackParams });
      const booking_res = await add_booking(data);
      if (booking_res.status === 1) {
        trackEvent("booking_request_done", { event_type: "booking_request", screen_name: "Payment Details", payment_method: "existing_card", ...paymentTrackParams });
        setModalShow(true);
        setLoading(false);
      } else {
        setLoading(false);
        consoleService(
          "Error in proceedfun booking res function = ",
          booking_res
        );
        toast(booking_res.message, {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in proceed fun function = ", err);
    }
  };

  const set_default_card_fun = async (card_id) => {
    try {
      setLoading(true);
      const res = await set_default_card({
        card_id,
      });
      if (res.status === 1) {
        getCardListFun();
      } else {
        setLoading(false);
        toast(res.message, {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in set_default_card_fun function = ", err);
    }
  };

  const showCardFieldsFun = () => {
    setShowCardFields(true);
    const updatedCardList = cardList.map((item) => {
      const newItem = item;
      newItem.default = false;
      return newItem;
    });
    setCardList([...updatedCardList]);
  };

  // STRIPE COMPONENT

  const StripForm = () => {
    const [name, setName] = useState("");
    const [isCardNumberValid, setIscardValid] = useState(false);
    const [isExpiryCardValid, setIsExpiryCardValid] = useState(false);
    const [isCvcValid, setIsCvcValid] = useState(false);
    const [stripe_loading, setStripeLoading] = useState(false);
    const stripe = useStripe();
    const elements = useElements();

    const stripe_submitFun = async (paymentMethodId) => {
      const stripeTrackParams = {
        ...getUserTrackingParams(user),
        therapist_name: therapistDetails?.name,
        session_type: `${priceData?.time_in_min}min`,
        value: calculated_price,
        currency: "USD",
      };
      const res = await create_card({
        paymentMethodId,
      });
      try {
        if (res.status === 1) {
          const data = {
            therapist_id: therapistDetails._id,
            pricing_id: priceData.id,
            slot_minutes: priceData.time_in_min,
            price: priceData.price,
            coupon_id: isCouponApplied ? coupon._id : "",
            date,
            time,
            payment_method: paymentMethodId,
          };
          trackEvent("start_booking_req", { event_type: "event", screen_name: "Payment Details", payment_method: "new_card", ...stripeTrackParams });
          const booking_res = await add_booking(data);
          if (booking_res.status === 1) {
            trackEvent("booking_request_done", { event_type: "booking_request", screen_name: "Payment Details", payment_method: "new_card", ...stripeTrackParams });
            setStripeLoading(false);
            setModalShow(true);
          } else {
            consoleService(
              "Error in submit booking res function = ",
              booking_res
            );
          }
        } else {
          consoleService("Error in submit card function = ", res);
        }
      } catch (err) {
        consoleService("Error in submit function = ", err);
      }
    };

    const handleSubmit = async (event) => {
      trackButtonClick("pay_now_cta", {
        button_name: `Pay $${calculated_price}`,
        screen_name: "Payment Details",
        payment_method: "new_card",
        ...getUserTrackingParams(user),
        therapist_name: therapistDetails?.name,
        session_type: `${priceData?.time_in_min}min`,
        value: calculated_price,
        currency: "USD",
      });
      setStripeLoading(true);
      event.preventDefault();
      if (!stripe || !elements) {
        return;
      }

      const cardNumberElement = elements.getElement(CardNumberElement);

      if (
        !isCardNumberValid ||
        !isExpiryCardValid ||
        !isCvcValid ||
        !name.trim()
      ) {
        return toast("Invalid card details.", {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
      }

      // Use your card Element with other Stripe.js APIs
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: "card",
        card: cardNumberElement,
        billing_details: {
          name: name, // Attach the customer's name here
        },
      });

      if (error) {
        consoleService("[error]", error);
        setStripeLoading(false);
        return toast("Invalid card details.", {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
      } else {
        stripe_submitFun(paymentMethod.id);
      }
    };
    const inputStyle = {
      style: {
        base: {
          fontSize: "15px",
          padding: "20px",
          color: "black",
          fontFamily: "Helvetica Neue",
          "::placeholder": {
            color: "#595c5f",
          },
        },
        invalid: {
          color: "#EB0823",
        },
      },
    };
    return (
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-4" controlId="exampleForm.ControlInput3">
          <Form.Label>Card Number</Form.Label>
          <CardNumberElement
            options={{
              ...inputStyle,
              placeholder: "Card Number",
            }}
            onChange={(value) => {
              setIscardValid(value.complete);
            }}
          />
        </Form.Group>

        <div className="row mb-4">
          <div className="col-md-8">
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput3">
              <Form.Label>Valid Thru</Form.Label>
              <CardExpiryElement
                options={{
                  ...inputStyle,
                  placeholder: "Month/Year",
                }}
                onChange={(value) => {
                  setIsExpiryCardValid(value.complete);
                }}
              />
            </Form.Group>
          </div>
          <div className="col-md-4">
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput3">
              <Form.Label>CVV</Form.Label>
              <CardCvcElement
                options={{
                  ...inputStyle,
                  placeholder: "Cvv",
                }}
                onChange={(value) => {
                  setIsCvcValid(value.complete);
                }}
              />
            </Form.Group>
          </div>
        </div>
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput3">
          <Form.Label>Card Holder’s Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Name of card holder"
            value={name}
            style={{ paddingLeft: 0 }}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </Form.Group>
        <Button
          disabled={
            !stripe ||
            stripe_loading ||
            !isCardNumberValid ||
            !isExpiryCardValid ||
            !isCvcValid ||
            !name.trim()
          }
          type="submit"
          variant="primary"
          className="mt-3"
        >
          {stripe_loading ? (
            <ReactLoader type="bubble-loop" bgColor={"white"} size={40} />
          ) : (
            `Pay $${calculated_price}`
          )}
        </Button>
      </Form>
    );
  };

  const StripeProvider = () => {
    return (
      <Elements stripe={stripePromise}>
        <StripForm />
      </Elements>
    );
  };

  // NESTED COMPONENTS

  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="sm"
        className="modalSuccess"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <Image src={SuccessIcon} alt="" />
          <h4>Confirmed</h4>
          <p>
            Your appointment has been scheduled and will update the status as
            soon as it's accepted.
          </p>
          <h4 style={{ fontSize: "1em" }}>{props.therapistDetails.name}</h4>
          <p>
            {formet_date(props.time)} | {formet_time(props.time)} <br />
            {props.therapistDetails.speciality_name.map((item, index) => {
              return simpleArrayString(
                item,
                index,
                props.therapistDetails.speciality_name
              );
            })}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-primary"
            onClick={() => {
              setModalShow(false);
              navigate(-1, { replace: true });
            }}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  // COUPON MODAL

  function CouponModal(props) {
    const couponList = props.couponList;
    const [searchValue, setSearchValue] = useState("");
    const [submit, setSubmit] = useState(false);
    const [errorValue, setErrorValue] = useState("");

    const appyCouponFun = () => {
      if (searchValue.trim()) {
        setSubmit(true);
        const filterValue = couponList.find(
          (item) => item.coupon_code.toLowerCase() == searchValue.toLowerCase()
        );
        if (filterValue) {
          handleCouponModal();
          setCoupon(filterValue);
          setSubmit(false);
          setErrorValue("");
        } else {
          setErrorValue("Invaild Coupon Code");
        }
      } else {
        return;
      }
    };

    const appyCouponFunByBtn = (coupon) => {
      handleCouponModal();
      setCoupon(coupon);
    };
    return (
      <Modal
        {...props}
        size="md"
        className="modalSuccess"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="coupon_container">
            <div className="coupon_sub_Container">
              <div className="search_coupon">
                <Form.Control
                  type="search"
                  placeholder="Search Coupon By Code"
                  aria-describedby="passwordHelpBlock"
                  value={searchValue}
                  onKeyDown={(e) => {
                    if (e.key == "Enter") {
                      e.preventDefault();
                      appyCouponFun();
                    }
                  }}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSearchValue(value);
                  }}
                />
                <Button
                  onClick={() => {
                    appyCouponFun();
                  }}
                  disabled={!searchValue.trim()}
                  className="btn btn-primary "
                >
                  Apply
                </Button>
              </div>
              {submit && errorValue && (
                <div className="errorDiv">
                  <span className="error_txt">{errorValue}</span>
                </div>
              )}
              <div>
                {couponList.length > 0 ? (
                  couponList.map((item, index) => {
                    return (
                      <div className="coupon_div" key={index}>
                        <div className="offer_box">
                          <span>
                            {item.discount_type == "amount"
                              ? `$${item.discount_value}`
                              : `${item.discount_value}%`}
                          </span>
                        </div>
                        <div className="second_offer_box">
                          <span className="coupon_title">{item.title}</span>
                          <span className="coupon_code">
                            <span>Code </span>
                            {item.coupon_code}
                          </span>
                        </div>
                        <div className="third_offer_box">
                          <Button
                            onClick={() => {
                              appyCouponFunByBtn(item);
                            }}
                            className="btn btn-primary "
                          >
                            Apply
                          </Button>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div>
                    <Loader
                      style={{
                        position: "relative",
                        backgroundColor: "white",
                        top: "10rem",
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  return (
    <>
      <BannerSection banner={Banner} name={"Home"} title={"Payment Details"} />
      <section className="py-5 card_payment">
        <div className="container">
          {initial_loading && (
            <div className="row">
              <div className="col-md-12">
                {cardList.length > 0 && (
                  <>
                    <div className="card_details_header">
                      <h4 className="mb-4 ft-medium">Card details</h4>{" "}
                      {couponList.length > 0 && (
                        <span
                          className="addCard"
                          onClick={() => {
                            handleCouponModal();
                          }}
                        >
                          Apply Coupon
                        </span>
                      )}
                    </div>

                    {cardList.map((item, index) => {
                      return (
                        <div className="d-flex flex-row pb-3" key={index}>
                          <Form.Group controlId="exampleForm.ControlInput3">
                            {["radio"].map((type) => (
                              <div
                                key={`default-${type}`}
                                className="p-1 px-0 me-2"
                              >
                                <Form.Check // prettier-ignore
                                  type={type}
                                  checked={item.default}
                                  id={item.id}
                                  label=""
                                  style={{ paddingLeft: 0 }}
                                  onClick={() => {
                                    if (item.default) return;
                                    set_default_card_fun(item.id);
                                  }}
                                />
                              </div>
                            ))}
                          </Form.Group>

                          <div
                            onClick={() => {
                              if (item.default) return;
                              set_default_card_fun(item.id);
                            }}
                            className="rounded border d-flex w-100 p-3 align-items-center cardFontMedia cursor_pointer"
                          >
                            <p className="mb-0">
                              <img
                                src={getCardBrandIconPath(item.card.brand)}
                                width={40}
                                className="me-2"
                                alt=""
                              />
                              <span style={{ marginLeft: 10 }}>
                                {" "}
                                {capitalizeFirstLetter(item.card.brand)} Debit
                                Card
                              </span>
                            </p>
                            <div className="ms-auto">
                              **** **** **** {item.card.last4}
                            </div>
                          </div>
                        </div>
                      );
                    })}

                    {!isCouponApplied && <hr />}
                    {isCouponApplied && (
                      <div className="coupon_container coupon_con2 coupon_m">
                        <div className="coupon_sub_Container coupon_sub_con2">
                          <div className="coupon_div">
                            <div className="offer_box">
                              <span>
                                {coupon.discount_type == "amount"
                                  ? `$${coupon.discount_value}`
                                  : `${coupon.discount_value}%`}
                              </span>
                            </div>
                            <div className="second_offer_box">
                              <span className="coupon_title">
                                {coupon.title}
                              </span>
                              <span className="coupon_code">
                                <span>Code </span>
                                {coupon.coupon_code}
                              </span>
                            </div>
                            <div className="third_offer_box">
                              <Button
                                onClick={() => {
                                  setCoupon({});
                                }}
                                className="btn btn-primary "
                              >
                                Remove
                              </Button>
                            </div>
                          </div>
                        </div>
                        <div className="discount_des coupon_m">
                          <div>
                            <span>Price</span>
                            <span>${priceData.price}</span>
                          </div>
                          <div>
                            <span>Discount</span>
                            <span>- ${calculated_discount}</span>
                          </div>
                          <hr />
                          <div>
                            <span>Total</span>
                            <span>${calculated_price}</span>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {!showCardFields && (
                    <Button
                      onClick={() => {
                        proceedfun();
                      }}
                      className="btn btn-primary bookbtn"
                    >
                      {`Pay $${calculated_price}`}
                    </Button>
                  )}
                  {!showCardFields && (
                    <span
                      className="addCard"
                      onClick={() => {
                        showCardFieldsFun();
                      }}
                    >
                      Add New Card
                    </span>
                  )}
                </div>

                {showCardFields && <StripeProvider />}

                <MyVerticallyCenteredModal
                  show={modalShow}
                  onHide={() => {
                    setModalShow(false);
                    navigate(-1, { replace: true });
                  }}
                  date={date}
                  time={time}
                  therapistDetails={therapistDetails}
                />

                <CouponModal
                  show={couponModal}
                  onHide={() => setCouponModal(false)}
                  couponList={couponList}
                />
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default EnterPaymentDetails;
